import { render, staticRenderFns } from "./FoodcourtFeedback.vue?vue&type=template&id=523d5380"
import script from "./FoodcourtFeedback.vue?vue&type=script&lang=js"
export * from "./FoodcourtFeedback.vue?vue&type=script&lang=js"
import style0 from "./FoodcourtFeedback.vue?vue&type=style&index=0&id=523d5380&prod&lang=scss"
import style1 from "./FoodcourtFeedback.vue?vue&type=style&index=1&id=523d5380&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports